import { jsx as r } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as p } from "../../../../context/theme/hooks.js";
import "../../../layout/Stack/Stack.js";
import n from "../../../layout/Box/Box.js";
import "react";
import "../../../../index-CZ8zjHGv.js";
import d from "../../../layout/Center/Center.js";
import "../../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../../layout/Columns/ColumnsContext.js";
function j({
  size: o,
  padding: i = "none",
  children: e,
  backgroundColor: t
}) {
  const m = p();
  return /* @__PURE__ */ r(
    n,
    {
      width: o,
      height: o,
      borderRadius: "xxxlarge",
      backgroundColor: t ? m[t] : void 0,
      position: "absolute",
      bottom: "-3.12%",
      top: "62.5%",
      right: "-3.12%",
      left: "62.5%",
      padding: i,
      children: /* @__PURE__ */ r(d, { children: e })
    }
  );
}
export {
  j as default
};
